"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var shallow_equal_1 = require("shallow-equal");
exports.shallowEqualArrays = shallow_equal_1.shallowEqualArrays;
exports.shallowEqualObjects = shallow_equal_1.shallowEqualObjects;
var requestTransformer_1 = __importDefault(require("./requestTransformer"));
exports.createRequestTransformer = requestTransformer_1.default;
var getDisplayName_1 = __importDefault(require("./helpers/getDisplayName"));
exports.getDisplayName = getDisplayName_1.default;
var getMetadata_1 = __importDefault(require("./helpers/getMetadata"));
exports.getMetadata = getMetadata_1.default;
var isObjectEmpty_1 = __importDefault(require("./helpers/isObjectEmpty"));
exports.isObjectEmpty = isObjectEmpty_1.default;
var withLayers_1 = __importDefault(require("./helpers/withLayers"));
exports.withLayers = withLayers_1.default;
var withSources_1 = __importDefault(require("./helpers/withSources"));
exports.withSources = withSources_1.default;
var reserveeToSeatLabel_1 = __importStar(require("./helpers/reserveeToSeatLabel"));
exports.reserveeToSeatLabel = reserveeToSeatLabel_1.default;
exports.truncateUserName = reserveeToSeatLabel_1.truncateUserName;
var compareLngLat_1 = require("./helpers/compareLngLat");
exports.compareLngLatLike = compareLngLat_1.compareLngLatLike;
exports.compareLngLatBoundsLike = compareLngLat_1.compareLngLatBoundsLike;
var eventProps_1 = require("./eventProps");
exports.createPropToEventMap = eventProps_1.createPropToEventMap;
exports.extractEventCallbackProps = eventProps_1.extractEventCallbackProps;
var propTypes_1 = require("./propTypes");
exports.LngLatLike = propTypes_1.LngLatLikePropType;
exports.LngLatBoundsLike = propTypes_1.LngLatBoundsLikePropType;
exports.PitchPropType = propTypes_1.PitchPropType;
exports.BearingPropType = propTypes_1.BearingPropType;
exports.featureShape = propTypes_1.featureShapePropType;
var features_1 = require("./helpers/features");
exports.isSameFeature = features_1.isSameFeature;
exports.ensureUniqueFeatures = features_1.ensureUniqueFeatures;
